import { root } from '../../store/constants';

export class SessionRecorderHelper {
    startRecording() {
        root.analytics.record();
    }
}
